import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      getTempData: "getTempData"
    })
  }
};
